import type { Data } from '@repo/strapi-types'

export type ValidColumnKey = NonNullable<Data.Component<'enums.columns'>['column']>
export type ColumnMapping = typeof colsMapping
export type ValidColumnType = ColumnMapping[ValidColumnKey]

const TABLE_BANNER_FIRST_COL_WIDTH = '280px'
const TABLE_BANNER_OTHER_COL_WIDTH = '220px'
const TABLE_BANNER_PHONE_COL_WIDTH = '190px'

const colsMappingStatsSectionMinimal = {
	1: 'grid-cols-1 md:grid-cols-1',
	2: 'grid-cols-2 md:grid-cols-2',
	3: 'grid-cols-2 md:grid-cols-3',
	0: 'grid-cols-2 md:grid-cols-4', // for cardCount % 4 === 0 (4 cards)
} as const

const colsMappingStatsSection = {
	1: 'grid-cols-1 md:grid-cols-1',
	2: 'grid-cols-1 md:grid-cols-2',
	3: 'grid-cols-1 md:grid-cols-3',
	0: 'grid-cols-1 md:grid-cols-4', // for cardCount % 4 === 0 (4 cards)
} as const

const colsMapping = {
	'cols-1': 'grid-cols-1',
	'cols-2': 'md:grid-cols-2 grid-cols-1',
	'cols-3': 'lg:grid-cols-3 md:grid-cols-2 grid-cols-1',
	'cols-4': 'xl:grid-cols-4 lg:grid-cols-3 md:grid-cols-2 grid-cols-1',
} as const

export const getColsStatsSectionClass = (cols?: number): string =>
	colsMappingStatsSection[(cols ?? 1) as keyof typeof colsMappingStatsSection]

export const getColsStatsSectionMinimalClass = (cols?: number): string =>
	colsMappingStatsSectionMinimal[(cols ?? 1) as keyof typeof colsMappingStatsSectionMinimal]

export const getColsValue = (cols: ValidColumnKey | null | undefined): ValidColumnType | '' => {
	return colsMapping[cols ?? 'cols-2']
}

export const getGridTemplateCols = (
	cols: number,
	type = 'tableBanner',
	platform: 'phone' | 'desktop' = 'desktop',
) => {
	switch (type) {
		case 'tableBanner':
			if (cols <= 1) {
				return '1fr'
			}
			if (cols === 2) {
				return '1fr 1fr'
			}
			if (platform === 'phone') {
				return `${Array(cols).fill(TABLE_BANNER_PHONE_COL_WIDTH).join(' ')}`
			}
			return `${TABLE_BANNER_FIRST_COL_WIDTH} ${Array(cols - 1)
				.fill(TABLE_BANNER_OTHER_COL_WIDTH)
				.join(' ')}`
		default:
			return undefined
	}
}
